import { render, staticRenderFns } from "./MenuAlignment.vue?vue&type=template&id=6b0c16f8"
import script from "./MenuAlignment.vue?vue&type=script&lang=js"
export * from "./MenuAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports